import idb from "@/plugins/indexdb.js";
import { login } from "../../repositories/authRepository";
import UsersRepository from "../../repositories/usersRepository";

const bcrypt = require("bcryptjs");

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || null,
    loading: false,
    error: null,
    user: {}
  },
  mutations: {
    AUTH_REQUEST(state) {
      Object.assign(state, { loading: true, error: null });
    },

    AUTH_SUCCESS(state, token) {
      Object.assign(state, {
        loading: false,
        token: token,
        error: null
      });
    },

    AUTH_ERROR(state, payload) {
      Object.assign(state, {
        loading: false,
        token: null,
        error: payload || true
      });
    },

    LOGOUT(state) {
      Object.assign(state, {
        loading: false,
        token: null,
        error: null
      });
    },

    // Set loggedIn user
    SET_USER(state, user) {
      state.user = user;
    }
  },
  actions: {
    // Perform login action, store token in local storage
    async login({ commit }, payload) {
      
      commit("AUTH_REQUEST");

      // Clear user table
      await idb.db.user.clear();

      try {
        const result = await login(payload);

        localStorage.setItem("token", result.jwt_token);
        commit("AUTH_SUCCESS", result.jwt_token);

        // Create a hash from payload
        const hash = await bcrypt.hash(JSON.stringify(payload), 8);

        // Get Connected user info
        const res = await UsersRepository.getConnectedUser();

        // Add Hash to user table
        await idb.db.user.add({
          hash: hash,
          token: result.jwt_token,
          user: res.data
        });

        // Set loggedIn user
        const { user } = await idb.db.user.toCollection().first();
        commit("SET_USER", user);

      } catch (e) {
        commit("AUTH_ERROR", e);
        throw new Error("Login failed.")
      }
    },

    // Perform logout - remove token from storage
    async logout({ commit }) {
      localStorage.removeItem("token");
      commit("LOGOUT");
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isAuthenticated: state => state.isAuthenticated,

    // Return loggedIn user role
    getLoggedInUserRole: state => state.user.role,

    getLoggedInUserId: state => state.user.id
  }
};
